import { __assign, __read, __rest, __spread } from "tslib";
/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
  if (!api.metadata || !api.metadata.sdk) {
    return;
  }
  var _a = api.metadata.sdk,
    name = _a.name,
    version = _a.version;
  return {
    name: name,
    version: version
  };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = __spread(event.sdk.integrations || [], sdkInfo.integrations || []);
  event.sdk.packages = __spread(event.sdk.packages || [], sdkInfo.packages || []);
  return event;
}
/** Creates a SentryRequest from a Session. */
export function sessionToSentryRequest(session, api) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
  var envelopeHeaders = JSON.stringify(__assign(__assign({
    sent_at: new Date().toISOString()
  }, sdkInfo && {
    sdk: sdkInfo
  }), api.forceEnvelope() && {
    dsn: api.getDsn().toString()
  }));
  // I know this is hacky but we don't want to add `session` to request type since it's never rate limited
  var type = 'aggregates' in session ? 'sessions' : 'session';
  var itemHeaders = JSON.stringify({
    type: type
  });
  return {
    body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
    type: type,
    url: api.getEnvelopeEndpointWithUrlEncodedAuth()
  };
}
/** Creates a SentryRequest from an event. */
export function eventToSentryRequest(event, api) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
  var eventType = event.type || 'event';
  var useEnvelope = eventType === 'transaction' || api.forceEnvelope();
  var _a = event.debug_meta || {},
    transactionSampling = _a.transactionSampling,
    metadata = __rest(_a, ["transactionSampling"]);
  var _b = transactionSampling || {},
    samplingMethod = _b.method,
    sampleRate = _b.rate;
  if (Object.keys(metadata).length === 0) {
    delete event.debug_meta;
  } else {
    event.debug_meta = metadata;
  }
  var req = {
    body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
    type: eventType,
    url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth()
  };
  // https://develop.sentry.dev/sdk/envelopes/
  // Since we don't need to manipulate envelopes nor store them, there is no
  // exported concept of an Envelope with operations including serialization and
  // deserialization. Instead, we only implement a minimal subset of the spec to
  // serialize events inline here.
  if (useEnvelope) {
    var envelopeHeaders = JSON.stringify(__assign(__assign({
      event_id: event.event_id,
      sent_at: new Date().toISOString()
    }, sdkInfo && {
      sdk: sdkInfo
    }), api.forceEnvelope() && {
      dsn: api.getDsn().toString()
    }));
    var itemHeaders = JSON.stringify({
      type: eventType,
      // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
      // explicitly-set sampling decisions). Are we good with that?
      sample_rates: [{
        id: samplingMethod,
        rate: sampleRate
      }]
    });
    // The trailing newline is optional. We intentionally don't send it to avoid
    // sending unnecessary bytes.
    //
    // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
    var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
    req.body = envelope;
  }
  return req;
}